import { useEffect, useState } from 'react';

/**
 * Gibt den Wert erst nach einer Ruhephase weiter.
 *
 * Im Segment-Builder haengt daran die Live-Vorschau: ohne Verzoegerung liefe
 * bei jedem Tastendruck eine Auswertung ueber alle Kontakte.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [delayed, setDelayed] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDelayed(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return delayed;
}
